import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom"; // ⬅️ agregado

export default function EstablishmentsCarousel({
  establecimientos = [],
  autoPlay = true,
  interval = 4500,
  fullBleed = true,
}) {
  const [current, setCurrent] = useState(0);
  const [paused, setPaused] = useState(false);
  const touchStartX = useRef(null);
  const navigate = useNavigate(); // ⬅️ instancia para navegar SPA

  if (!establecimientos.length) return null;
  const canSlide = establecimientos.length > 1;
  // Ocultar botones y dots siempre, solo autoplay
  const showControls = false;
  const showButtons = false;

  const next = () => setCurrent((c) => (c + 1) % establecimientos.length);
  const prev = () =>
    setCurrent((c) => (c - 1 + establecimientos.length) % establecimientos.length);

  useEffect(() => {
    if (!autoPlay || !canSlide || paused) return;
    const id = setInterval(() => setCurrent((c) => (c + 1) % establecimientos.length), interval);
    return () => clearInterval(id);
  }, [autoPlay, canSlide, paused, interval]);

  const getFirstImage = (e) => {
    if (Array.isArray(e?.imagenes) && e.imagenes.length) {
      const f = e.imagenes[0];
      return typeof f === "string" ? f : f?.url || f?.path || "";
    }
    return e?.foto || "";
  };

  const mapUrl = (e) => {
    const q = [e?.nombre_negocio, e?.direccion].filter(Boolean).join(" ");
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(q)}`;
  };

  const est = establecimientos[current];
  const imgSrc = getFirstImage(est);

  // ⇩⇩ Ahora navega con React Router (sin recargar la página)
  const handleReservar = () => {
    navigate("/reservar");
  };

  const onTouchStart = (e) => (touchStartX.current = e.changedTouches[0].clientX);
  const onTouchEnd = (e) => {
    const d = e.changedTouches[0].clientX - (touchStartX.current ?? 0);
    if (Math.abs(d) > 40) d > 0 ? prev() : next();
    touchStartX.current = null;
  };


  // Fade solo en desktop, en móvil no se aplica para no tapar el botón
  const fadePx = 80;
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;
  const fadeMaskStyle = isMobile
    ? {} // sin máscara en móvil
    : {
        WebkitMaskImage: `linear-gradient(to bottom,
                          rgba(0,0,0,1) calc(100% - ${fadePx}px),
                          rgba(0,0,0,0) 100%)`,
        maskImage: `linear-gradient(to bottom,
                    rgba(0,0,0,1) calc(100% - ${fadePx}px),
                    rgba(0,0,0,0) 100%)`,
        WebkitMaskSize: "100% 100%",
        maskSize: "100% 100%",
        WebkitMaskRepeat: "no-repeat",
        maskRepeat: "no-repeat",
      };


  return (
    <div
      className={`select-none ${
        fullBleed ? "relative left-1/2 right-1/2 -mx-[50vw] w-screen" : "w-full"
      }`}
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      <div
        className="relative w-full overflow-hidden shadow-2xl rounded-none"
        style={fadeMaskStyle}
        onTouchStart={onTouchStart}
        onTouchEnd={onTouchEnd}
      >
        {/* imagen de fondo */}
        <div className="aspect-[16/9] md:aspect-[21/9] bg-gray-200">
          {imgSrc ? (
            <img
              src={imgSrc}
              alt={est?.nombre_negocio || "Establecimiento"}
              className="w-full h-full object-cover"
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center text-gray-400 text-2xl">
              Sin imagen
            </div>
          )}
        </div>

        {/* Panel informativo: lateral en desktop, inferior en móvil */}
        <div
          className="
            absolute left-0 right-0
            md:inset-y-0 md:w-[46%] lg:w-[42%] md:left-0 md:right-auto
            bg-gradient-to-br from-emerald-50/85 via-emerald-50/60 to-emerald-100/35
            backdrop-blur-md shadow-lg flex flex-col justify-center
            px-4 py-4 md:px-8 md:py-0 lg:px-12
            max-w-full md:max-w-lg
            break-words overflow-visible
            transition-all duration-300
            bottom-0 md:top-0
            z-10
            md:items-start items-center
            md:rounded-none rounded-t-2xl
            md:h-full h-auto
            md:clip-auto
          "
          style={{
            clipPath:
              window.innerWidth >= 768
                ? "polygon(0 0, 90% 0, 80% 100%, 0% 100%)"
                : undefined,
          }}
        >
          <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold text-slate-900 drop-shadow-sm text-center md:text-left">
            Reserva tu cancha con tranquilidad
          </h1>
          <p className="mt-2 sm:mt-4 text-base sm:text-lg md:text-xl text-slate-700 text-center md:text-left">
            Encuentra canchas cerca de ti y asegura tu horario en minutos. Sin llamadas, sin complicaciones.
          </p>
          <button
            onClick={handleReservar}
            className="pointer-events-auto mt-4 sm:mt-6 inline-flex items-center gap-2 rounded-full bg-green-600 px-5 sm:px-6 py-2.5 sm:py-3 text-base sm:text-lg text-white font-semibold shadow-lg hover:shadow-xl hover:scale-[1.02] active:scale-100 transition"
            aria-label="Reservar una cancha ahora"
          >
            Reservar ahora
            <span aria-hidden>📍</span>
          </button>
        </div>

        {/* flechas NEGRAS con detalle (ring, borde, sombra) */}
        {showButtons && (
          <>
            <button
              onClick={prev}
              aria-label="Anterior"
              className="absolute left-5 top-1/2 -translate-y-1/2
                         w-12 h-12 md:w-14 md:h-14 rounded-full
                         bg-black/80 text-white grid place-items-center
                         border border-white/10 ring-1 ring-white/20
                         shadow-[0_10px_30px_rgba(0,0,0,0.45)] backdrop-blur-sm
                         hover:ring-emerald-400/60 hover:bg-black
                         focus:outline-none focus:ring-4 focus:ring-emerald-400/60
                         transition transform hover:scale-105 active:scale-95"
            >
              <svg
                width="22"
                height="22"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
              >
                <path d="M15 18l-6-6 6-6" />
              </svg>
            </button>

            <button
              onClick={next}
              aria-label="Siguiente"
              className="absolute right-5 top-1/2 -translate-y-1/2
                         w-12 h-12 md:w-14 md:h-14 rounded-full
                         bg-black/80 text-white grid place-items-center
                         border border-white/10 ring-1 ring-white/20
                         shadow-[0_10px_30px_rgba(0,0,0,0.45)] backdrop-blur-sm
                         hover:ring-emerald-400/60 hover:bg-black
                         focus:outline-none focus:ring-4 focus:ring-emerald-400/60
                         transition transform hover:scale-105 active:scale-95"
            >
              <svg
                width="22"
                height="22"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
              >
                <path d="M9 6l6 6-6 6" />
              </svg>
            </button>
          </>
        )}

        {/* dots con énfasis esmeralda */}
        {showControls && (
          <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2">
            {establecimientos.map((_, i) => (
              <button
                key={i}
                onClick={() => setCurrent(i)}
                aria-label={`Ir al item ${i + 1}`}
                className={`h-2.5 w-6 rounded-full transition
                            ${
                              i === current
                                ? "bg-emerald-500 shadow ring-1 ring-white/40"
                                : "bg-white/40"
                            }`}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
